<template>
  <div class="tasks">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <TimeTrackingTable />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import TimeTrackingTable from '@/components/TimeTrackingTable';

export default {
  name: 'AdminTimeTracking',
  components: {
    Breadcrumbs,
    TimeTrackingTable,
  },
  data() {
    return {};
  },
  computed: {
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('time_tracking') }];
    },
  },

  methods: {},

  async mounted() {},
};
</script>

<style scoped lang="scss"></style>
